import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const ReportService = {

    getConversations: (params: {
        account_id: number,
        start_date: string,
        end_date: string,
    }) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.BOT_V3}reports/conversations`, { params });
    },
   
    getReportAgents: (account_id: number, day_init: string, day_end: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/get-agents-activity/${account_id}`, { params: { day_init, day_end} });
    },
    getReportAgentsPerDay: (account_id: number, day_init: string, day_end: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/download-detail-agents-activity/${account_id}`, { params: { day_init, day_end} });
    },


    getReportTickets: (account_id: number, day_init: string, day_end: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/get-tickets-close/${account_id}`, { params: { day_init, day_end} });
    },
    
    getReportPayments: (account_id: number, fecha_inicio: string, fecha_fin: string) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}payments/reports`, { account_id,  fecha_inicio, fecha_fin });
    },
    
    getReportCustomers: (account_id: number, day_init: string, day_end: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/get-clients-resume/${account_id}`, {  params: { day_init, day_end } });
    },
   
    getTicketDetail: (account_id: number, ticket_id: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/get-detail-ticket-close/${account_id}`, {  params: { ticket_id } });
    },

    getLogsTickets: (account_id: number, ticket_id: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/get-tickets-log-transaccion/${account_id}`, {  params: { ticket_id } });
    },
   
    getURLExternalFile(ticket_id: string, file_name: string): string {
        return `${API_ENDPOINT.CORE}stadistics/v3.1/extern/getFile?tt=${ticket_id}&file=${file_name}`;
    },
   
    getURLPublicFile(file_name: string): string {
        return `${API_ENDPOINT.CORE}stadistics/v3.1/extern/external-file?file=${file_name}`;
    },
   
    getURLLocation(lat: string, lng: string): string {
        return `https://maps.google.com/maps?q=${lat},${lng}&hl=es;z=10&output=embed`;
    },

    blockCustomer: (account_id: number, account_client_id: number) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/block-client/${account_id}`, { account_client_id });
    },
    
    unblockCustomer: (account_id: number, account_client_id: number) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/unblock-client/${account_id}`, { account_client_id });
    },
    
    updateCategoryTicket: (account_id: number, ticket_id: number, category: string) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/change-category-ticket-close/${account_id}`, { ticket_id, category });
    },
    
    getCustomerInfo: (account_id: number, account_client_id: number ) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/get-client-detail/${account_id}`, { params: { account_client_id } });
    },
    
    updateCustomerInfo: (account_id: number, name: string, account_client_id: number, info: string ) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/update-client/${account_id}`, { name, account_client_id, info });
    },
    
    createNewConversation: (account_id: number, data: any ) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/reopen-ticket-close/${account_id}`, data);
    },

    getBlacklist: (account_id: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}base-clients/v4.0/blacklist/get-all/${account_id}`)
    },

    addNumber: (account_id: number, number: string) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}base-clients/v4.0/blacklist/insert-number/${account_id}`, {number})
    },
    
    deleteNumber: (account_id: number, number_id: string) => {
        return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}base-clients/v4.0/blacklist/delete-number/${account_id}`, { data: { number_id } })
    },

    downloadCSV: (params) => {
        const query = [
          `token_api=${params.token_api}`,
          `accounts_id=${params.accounts_id}`,
          `date_init=${params.date_init}`,
          `date_end=${params.date_end}`,
          `number=${params.number}`,
          `categories=${params.categories}`,
        ];
        return `${API_ENDPOINT.CORE}stadistics/download/chats-csv?${query.join('&')}`;
    },

    getConversions: (account_id: number, init_date: string, end_date: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/convertion/get`, { 
            params: { 
                account_id, 
                init_date, 
                end_date 
            } 
        });
    },

    getSpecificConversion: (account_id: number, init_date: string, end_date: string, task: string, search: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/convertion/specific-report`, { 
            params: { 
                account_id, 
                init_date, 
                end_date ,
                task,
                search
            } 
        });
    },

    getApi: (account_id: number, date_init: string, date_end: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/extern/consumo-wa-api/${account_id}`, { 
            params: { 
                date_init, 
                date_end 
            }
        });
    },
    
}